<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="nav-tabs-wrap">
            <ul class="nav nav-tabs">
                <li><a :class="{'active' : match_team1.lineups.length }" data-toggle="tab" href="#teams-inn-tab1" aria-selected="true">Playing XI</a></li>
                <li><a :class="{'active' : !match_team1.lineups.length }" data-toggle="tab" href="#teams-inn-tab2" aria-selected="false">Squad</a></li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane fade show" :class="{'active' : match_team1.lineups.length }" id="teams-inn-tab1" role="tabpanel">
                 <div class="table-responsive">
                    <div class="match-table info">
                        <div class="thead">
                            <div class="table-row">
                                <div class="th">{{ match_team1.name }}</div>
                                <div class="th">{{ match_team2.name }}</div>
                            </div>
                        </div>

                        <div class="tab-pane fade show active text-center" v-if=" match_team1.lineups.length == 0 && match_team1.lineups.length == 0 ">
                            <p>Playing XI not added yet</p>
                        </div>
                        <div class="tab-pane fade show active text-center" v-else-if="match_team1.length != 0 && match_team1.length != 0 ">
                            <div class="table-body">
                                <div class="tbody">
                                    <div class="row">
                                        <div class="col-6 pr-0">
                                            <div class="table-row" v-for="player in match_team1.lineups" :key="player.id">
                                                <div class="td">
                                                    <router-link :to="{ name: 'playerDetail.info', params:  { player: player.slug || (player.name + ' ' + player.id).slugify()} }">
                                                        <span class="title d-none d-md-block"><u>{{ player.name }}</u></span>
                                                        <span class="title d-md-none"><u>{{ player.short_name }}</u></span>
                                                    </router-link>

                                                    <span class="sub-title">{{ player.batting_style != 'null' ? player.batting_style : '&nbsp' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 pl-0">
                                            <div class="table-row" v-for="player in match_team2.lineups" :key="player.id">
                                                <div class="td text-right">
                                                    <router-link :to="{ name: 'playerDetail.info', params:  { player: player.slug || (player.name + ' ' + player.id).slugify()} }">
                                                        <span class="title d-none d-md-block"><u>{{ player.name }}</u></span>
                                                        <span class="title d-md-none"><u>{{ player.short_name }}</u></span>
                                                    </router-link>
                                                    <span class="sub-title">{{ player.batting_style != 'null' ? player.batting_style : '&nbsp' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>

                    </div>
                </div>
            </div>


            <div class="tab-pane fade show" :class="{'active' : !match_team1.lineups.length }" id="teams-inn-tab2" role="tabpanel">
                <div class="table-responsive">
                    <div class="match-table info">
                        <div class="thead">
                            <div class="table-row">
                                <div class="th">{{ match_team1.name }}</div>

                                <div class="th">{{ match_team2.name }}</div>
                            </div>
                        </div>
                        <div class="tab-pane fade show active text-center" v-if="team_squards.length == 0">
                            <p>Squad Not Available Yet</p>
                        </div>
                        <div class="tab-pane fade show active text-center" v-else-if="team_squards.length != 0">
                            <div class="table-body">
                                <div class="tbody">
                                    <div class="row">
                                        <div class="col-6 pr-0">

                                            <div class="table-row" v-for="team_squard in team_squards" :key="team_squard.id" v-if="match_team1.id == team_squard.team_id">
                                                <div class="td">
                                                    <router-link :to="{ name: 'playerDetail.info', params:  { player: team_squard.player.slug} }">
                                                        <span class="title d-none d-md-block"><u>{{ team_squard.player.name }}</u></span>
                                                        <span class="title d-md-none"><u>{{ team_squard.player.short_name }}</u></span>

                                                    </router-link>

                                                    <span class="sub-title">{{ team_squard.role }}</span>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 pr-0">
                                            <div class="table-row" v-for="team_squard in team_squards" :key="team_squard.id" v-if="match_team2.id == team_squard.team_id">
                                                <div class="td text-right">
                                                    <router-link :to="{ name: 'playerDetail.info', params:  { player: team_squard.player.slug} }">
                                                        <span class="title d-none d-md-block"><u>{{ team_squard.player.name }}</u></span>
                                                        <span class="title d-md-none"><u>{{ team_squard.player.short_name }}</u></span>
                                                    </router-link>

                                                    <span class="sub-title">{{ team_squard.role || '&nbsp' }}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    export default {
        name: 'Teams',

        components: {},

        data() {
            return {
                match_team1: [],
                match_team2: [],
                team_squards: [],
                players:[],
            }
        },


        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

                let persons = []
                this.players.forEach((player) => {
                persons.push(
                        {
                            "@type": "Person",
                            "name": player.name,
                            "description": player.batting_style,
                            "image": "https://planetcricket.com/public/images/logo1280x720.png"
                        }
                )
            });
                return {
                "@context": "http://schema.org",
                "@graph": persons
            }
        },


        metaInfo() {
            if (!Components['MatchDetail'])
                return
          //  let title = Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name +" Teams "+ " - PlanetCricket.com";
          //  let description = "Teams - " + Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name + " - PlanetCricket.com";
            let title = Components['MatchDetail'].setTitle() + "Teams - " + Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name + " - Planet Cricket";
            let description = "Teams - " + Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name + " - Planet Cricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.getMatchDetail();
            }
        },
        mounted() {
            this.getMatchDetail()
        },
        methods: {
            getMatchDetail() {
                return this.$axios
                        .get(this.$MATCH_TEAM_API.replace(':match', this.$route.params.match))
                        .then(response => {
                            this.is_data_ready = true;
                            this.match_team1 = response.data.result.teams.team1 || [];
                            this.match_team2 = response.data.result.teams.team2 || [];
                            this.team_squards = response.data.result.team_squards || [];
                            this.players = [...this.match_team1.lineups,...this.match_team2.lineups];
                            this.team_squards.forEach(element => {
                                this.players.push(element.player)
                            });
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>
